import "./src/styles/global.css"

const JOURNEY_KEY = "moden_journey_v1"
const VISITOR_KEY = "moden_internal_visitor_v1"
const SESSION_KEY = "moden_internal_session_v1"
const INTERNAL_ENDPOINT = "https://clinic-os.moden.marketing/api/analytics/track"
const BRAND_HOSTS = new Set(["clinic-os.moden.marketing", "modenpress.com"])
const AI_REFERRERS = new Map([
  ["chatgpt.com", "chatgpt"],
  ["chat.openai.com", "chatgpt"],
  ["perplexity.ai", "perplexity"],
  ["claude.ai", "claude"],
  ["gemini.google.com", "gemini"],
  ["copilot.microsoft.com", "copilot"],
])

const referrerSource = () => {
  try {
    const host = new URL(document.referrer).hostname.toLowerCase().replace(/^www\./, "")
    return AI_REFERRERS.get(host) || null
  } catch {
    return null
  }
}

const getTrackingId = (storage, key, prefix) => {
  try {
    const existing = storage.getItem(key)
    if (existing) return existing
    const id = `${prefix}${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`}`
    storage.setItem(key, id)
    return id
  } catch {
    return `${prefix}unavailable`
  }
}

const sendInternal = (payload) => {
  try {
    const query = new URLSearchParams(window.location.search)
    const body = JSON.stringify({
      site: "modenmarketing",
      sessionId: getTrackingId(window.sessionStorage, SESSION_KEY, "mms_"),
      visitorId: getTrackingId(window.localStorage, VISITOR_KEY, "mmv_"),
      path: window.location.pathname,
      referrer: document.referrer || null,
      ai_referrer: referrerSource(),
      userAgent: navigator.userAgent,
      utm_source: query.get("utm_source"),
      utm_medium: query.get("utm_medium"),
      utm_campaign: query.get("utm_campaign"),
      utm_content: query.get("utm_content"),
      utm_term: query.get("utm_term"),
      ...payload,
    })
    if (navigator.sendBeacon) {
      navigator.sendBeacon(INTERNAL_ENDPOINT, new Blob([body], { type: "application/json" }))
    } else {
      fetch(INTERNAL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {})
    }
  } catch {
    // Analytics must never affect the page experience.
  }
}

const getJourney = () => {
  try {
    const existing = JSON.parse(window.localStorage.getItem(JOURNEY_KEY) || "null")
    if (existing?.id) return existing

    const query = new URLSearchParams(window.location.search)
    const journey = {
      id: query.get("journey_id") || window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`,
      landingPage: window.location.pathname,
      source: query.get("utm_source") || document.referrer || "direct",
      createdAt: new Date().toISOString(),
    }
    window.localStorage.setItem(JOURNEY_KEY, JSON.stringify(journey))
    return journey
  } catch {
    return { id: "unavailable", landingPage: window.location.pathname, source: "unavailable" }
  }
}

const emit = (name, params) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: name, ...params })
  if (typeof window.gtag === "function") window.gtag("event", name, params)
}

export const onClientEntry = () => {
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.("a[href]")
    if (!link) return

    let url
    try {
      url = new URL(link.href, window.location.href)
    } catch {
      return
    }

    const journey = getJourney()
    const label = (link.dataset.trackLabel || link.textContent || "").trim().slice(0, 80)
    const common = {
      journey_id: journey.id,
      journey_source: journey.source,
      landing_page: journey.landingPage,
      page_path: window.location.pathname,
      link_label: label,
      destination_host: url.hostname,
    }

    if (url.origin === window.location.origin && url.pathname.startsWith("/consult")) {
      emit("consult_click", { ...common, funnel_stage: "consult" })
      sendInternal({ type: "event", eventType: "cta_click", eventData: { ...common, cta_kind: "consult" } })
      return
    }

    if (url.hostname === "open.kakao.com") {
      emit("consult_click", { ...common, funnel_stage: "consult" })
      sendInternal({ type: "event", eventType: "cta_click", eventData: { ...common, cta_kind: "consult" } })
      return
    }

    if (BRAND_HOSTS.has(url.hostname)) {
      url.searchParams.set("journey_id", journey.id)
      url.searchParams.set("journey_source", "agency")
      link.href = url.toString()
      emit("brand_bridge_click", { ...common, funnel_stage: "consideration" })
      sendInternal({
        type: "event",
        eventType: "cta_click",
        eventData: { ...common, cta_kind: url.pathname.startsWith("/consult") ? "consult" : "brand_bridge" },
      })
    }
  }, true)
}

export const onRouteUpdate = () => {
  sendInternal({ type: "pageview" })
}
